import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BciSidebarService } from '@bci-web-core/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ButtonConfig } from 'src/app/models/button.component.model';
import { AuthService } from 'src/app/services/auth.service';
import { WarningDialog } from 'src/app/shared/index';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  langData: any;
  constructor(
    private authService: AuthService,
    private sidebarService: BciSidebarService,
    private router: Router,
    public dialog: MatDialog,
    public translate: TranslateService
  ) {
    this.translate.stream('dialogBox').subscribe((subStream: any) => {
      this.langData = subStream;
    });
  }

  isDialogOpened = false;
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // const started = Date.now();
    // return next.handle(request).pipe(
    //   catchError((error: HttpErrorResponse) => {
    //     if (error.status !== 401) {
    //       // 401 handled in auth.interceptor
    //       console.error('after:' + error.message);
    //     }
    //     return throwError(error);
    //   })
    // );
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.error !== undefined) {
          const message = error.error.message.trim().toLowerCase();
          if (
            message.includes(
              'full authentication is required to access this resource'
            ) ||
            message.includes('invalid access token')
          ) {
            if (this.router.url !== '/') {
              if (this.dialog.openDialogs.length === 0) {
                this.isDialogOpened = true;
                const dialogRef = this.dialog.open(WarningDialog, {
                  width: '50%'
                });
                dialogRef.componentInstance.confirmMessage =
                  this.langData.sessionExpire;
                dialogRef.componentInstance.buttonConfig = [
                  new ButtonConfig('Close', false, true, () =>
                    dialogRef.close(false)
                  )
                ];
                dialogRef.afterClosed().subscribe(() => {
                  console.error('after:' + error.message);
                  console.log('Access token expired !');
                  this.isDialogOpened = false;
                  this.authService.logout();
                  this.sidebarService.setSidebarVisibility(false);
                  this.router.navigate(['/']);
                });
              }
            }
            return;
          }
        }
        return throwError(error);
      })
    );
  }
}
